class LLMUsage {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/llm-usage`;

  }

  getToday() {

    const path = `${this.basePath}/today`;

    return this.apiClient.get(path, {}, {});

  }

}

export default LLMUsage;
